import { GENERATE_CLIENT_TOKEN_SUCCESS, GENERATE_CLIENT_TOKEN_FAILURE, GENERATE_CLIENT_TOKEN, TRANSACTION_SALE_SUCCESS, TRANSACTION_SALE, TRANSACTION_SALE_FAILURE, BRAINTREE_RESPONSE, TRANSACTION_VOID_FAILURE, TRANSACTION_VOID_SUCCESS, TRANSACTION_VOID, TRANSACTION_SUBMIT_FAILURE, TRANSACTION_SUBMIT_SUCCESS, TRANSACTION_SUBMIT, SET_FETCH_RECENT_PAYMENT_METHOD_LOADER, RESET_BRAINTREE_REDUCER, } from '../../constants';
const initialState = {
    isGenerateClientTokenLoading: false,
    generateClientTokenSuccess: false,
    token: '',
    transactionSaleLoading: false,
    transactionSaleSuccess: false,
    transactionSale: '',
    braintreeResponse: {},
    transactionSubmitLoading: false,
    transactionSubmitSuccess: false,
    transactionSubmit: '',
    transactionVoidLoading: false,
    transactionVoidSuccess: false,
    transactionVoid: '',
    fetchRecentPaymentMethodLoading: false,
};
const braintreePaymentReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case GENERATE_CLIENT_TOKEN:
            return {
                ...state,
                isGenerateClientTokenLoading: true,
                token: '',
            };
        case GENERATE_CLIENT_TOKEN_SUCCESS:
            return {
                ...state,
                isGenerateClientTokenLoading: false,
                generateClientTokenSuccess: true,
                token: action.response,
            };
        case GENERATE_CLIENT_TOKEN_FAILURE:
            return {
                ...state,
                isGenerateClientTokenLoading: false,
                generateClientTokenSuccess: false,
                token: '',
            };
        case TRANSACTION_SALE:
            return {
                ...state,
                transactionSaleLoading: true,
                transactionSale: '',
            };
        case TRANSACTION_SALE_SUCCESS:
            return {
                ...state,
                transactionSaleLoading: false,
                transactionSaleSuccess: true,
                transactionSale: action.response,
            };
        case TRANSACTION_SALE_FAILURE:
            return {
                ...state,
                transactionSaleLoading: false,
                transactionSaleSuccess: false,
                transactionSale: '',
            };
        case BRAINTREE_RESPONSE:
            return {
                ...state,
                braintreeResponse: action.payload,
                fetchRecentPaymentMethodLoading: false,
            };
        case TRANSACTION_SUBMIT:
            return {
                ...state,
                transactionSubmitLoading: true,
                transactionSubmit: '',
            };
        case TRANSACTION_SUBMIT_SUCCESS:
            return {
                ...state,
                transactionSubmitLoading: false,
                transactionSubmitSuccess: true,
                transactionSubmit: action.response,
            };
        case TRANSACTION_SUBMIT_FAILURE:
            return {
                ...state,
                transactionSubmitLoading: false,
                transactionSubmitSuccess: false,
                transactionSubmit: '',
            };
        case TRANSACTION_VOID:
            return {
                ...state,
                transactionVoidLoading: true,
                transactionVoid: '',
            };
        case TRANSACTION_VOID_SUCCESS:
            return {
                ...state,
                transactionVoidLoading: false,
                transactionVoidSuccess: true,
                transactionVoid: action.response,
            };
        case TRANSACTION_VOID_FAILURE:
            return {
                ...state,
                transactionVoidLoading: false,
                transactionVoidSuccess: false,
                transactionVoid: '',
            };
        case SET_FETCH_RECENT_PAYMENT_METHOD_LOADER:
            return {
                ...state,
                fetchRecentPaymentMethodLoading: action.payload,
            };
        case RESET_BRAINTREE_REDUCER:
            return {
                ...state,
                isGenerateClientTokenLoading: false,
                generateClientTokenSuccess: false,
                token: '',
                transactionSaleLoading: false,
                transactionSaleSuccess: false,
                transactionSale: '',
                braintreeResponse: {},
                transactionSubmitLoading: false,
                transactionSubmitSuccess: false,
                transactionSubmit: '',
                transactionVoidLoading: false,
                transactionVoidSuccess: false,
                transactionVoid: '',
                fetchRecentPaymentMethodLoading: false,
            };
        default:
            return state;
    }
};
export default braintreePaymentReducer;
